import React from "react";
import { useHistory } from "react-router-dom";
//Material imports
import { useTheme } from "@mui/material/styles";
const DEFAULT_BREADCRUMB = [{
  text: "Portal Select"
}];
export const useNavigationHook = () => {
  const [hasScreenSizeChanged, setHasScreenSizeChanged] = React.useState(0);
  const [breadcrumb, setBreadcrumb] = React.useState(DEFAULT_BREADCRUMB);
  const [navItems, setNavItems] = React.useState([]);
  const [currentLocation, setCurrentLocation] = React.useState("");
  const history = useHistory();
  //const location = useLocation();
  const theme = useTheme();
  React.useEffect(() => {
    window.removeEventListener("resize", handleScreenResolutionChange);
    window.addEventListener("resize", handleScreenResolutionChange);
    return () => {
      window.removeEventListener("resize", handleScreenResolutionChange);
    };
  }, []);
  React.useEffect(() => {
    if (history.location.pathname !== "/portal-selection") {
      if (navItems.length > 0) {
        navItems.map(item => {
          if (item.path === history.location.pathname || history.location.pathname.includes(item.path.split(":")[0])) {
            // In case breadcrumb includes dynamic route
            const breadcrumb = updateBreadCrumbs(item.breadcrumb, history.location.pathname.split(item.path.split(":")[0])[1]);
            setCurrentLocation(history.location.pathname);
            setBreadcrumb(breadcrumb);
          }
        });
      }
    }
  }, [history.location.pathname, navItems]);
  const updateBreadCrumbs = (breadcrumb, dynamicValue) => breadcrumb.map(item => {
    if (item.dynamicText) {
      item.text = dynamicValue;
    }
    return item;
  });
  const handleScreenResolutionChange = event => {
    //force react to re-calculate the breakpoint via isLargeScreen
    setHasScreenSizeChanged(event.timeStamp);
  };
  const isLargeScreen = React.useMemo(() => {
    const keys = [...theme.breakpoints.keys].reverse();
    const width = keys.reduce((output, key) => {
      const mq = window.matchMedia(theme.breakpoints.up(key).replace("@media ", ""));
      return !output && mq.matches ? key : output;
    }, null) || "xs";
    return width === "lg" || width === "xl";
  }, [hasScreenSizeChanged]);
  const [isNavigationExpanded, setIsNavigationExpanded] = React.useState(isLargeScreen);
  React.useEffect(() => {
    setIsNavigationExpanded(isLargeScreen);
  }, [isLargeScreen]);
  const navigate = (link, replace = false) => {
    // prevent warning about updating when new path is the same as current
    if ((history === null || history === void 0 ? void 0 : history.location.pathname) !== link) {
      if (replace) {
        history.replace(link);
      } else {
        history.push(link);
      }
    }
  };
  const toggleNavigationDrawer = () => {
    setIsNavigationExpanded(!isNavigationExpanded);
  };
  return {
    navigate,
    isNavigationExpanded,
    setIsNavigationExpanded,
    toggleNavigationDrawer,
    isLargeScreen,
    breadcrumb,
    setBreadcrumb,
    setNavItems,
    currentLocation
  };
};